<template>
  <section
    class="cta section center-content-mobile reveal-from-bottom"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color'
    ]"
  >
    <div class="container">
      <div
        class="cta-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
          split && 'cta-split'
        ]"
      >
        <div class="cta-slogan">
          <h3 class="m-0">Ready to start a conversation?</h3>
        </div>
        <div class="cta-action">
          <form ref="formCta" name="footer-contact" method="POST" data-netlify="true">
            <div class="flex-l">
              <c-button tag="router-link" to="/contact">
                <div class="image-button">
                  <svg
                    width="16"
                    height="12"
                    xmlns="http://www.w3.org/2000/svg"
                    class="hidden-sm mr-12"
                  >
                    <path d="M9 5H1c-.6 0-1 .4-1 1s.4 1 1 1h8v5l7-6-7-6v5z" fill="rgba(0,0,0,0.5)" />
                  </svg>
                  Reach out
                </div>
              </c-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from "@/utils/SectionProps.js";
import { isValidEmail } from "@/utils/Helpers.js";
import CButton from "@/components/elements/Button.vue";

export default {
  name: "CCta",
  components: {
    CButton
  },
  mixins: [SectionProps],
  props: {
    split: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    emailIsValid() {
      return isValidEmail(this.ctaValue);
    }
  },
  data() {
    return {
      ctaValue: null
    };
  },
  methods: {
    handleSubmit() {
      // eslint-disable-next-line
      if (this.ctaValue && this.emailIsValid) this.$refs.formCta.submit();
    }
  }
};
</script>

<style scoped>
.image-button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
</style>
